import { Skeleton } from '@material-ui/lab';
import type { FC } from 'react';
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import type { Asset } from '../../lib/graph/MogulMarketplace';
import { NftCard } from './card/NftCard.component';
import styles from './Marketplace.module.css';

interface MarketplaceProps {
  assets?: Asset[];
  count?: number;
  yourNfts?: boolean;
  isFeaturedOrTrending?: boolean;
  showViewCollection?: boolean;
}

export const MarketplaceComponent: FC<MarketplaceProps> = ({
  assets,
  count = 10,
  yourNfts,
  isFeaturedOrTrending = false,
  showViewCollection = true,
}) => {
  const carouselNftList = () => {
    return (
      <Swiper
        navigation={true}
        loop={true}
        freeMode={true}
        freeModeMinimumVelocity={0.4}
        freeModeMomentum={true}
        style={{ maxHeight: 'unset' }}
        direction="horizontal"
        grabCursor={true}
        preventClicksPropagation={true}
        preventClicks={true}
        initialSlide={1}
        className={styles.swiperContainer}
        breakpoints={{
          200: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          500: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          700: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          840: {
            slidesPerView: 2,
            spaceBetween: 0,
          },
          1100: {
            slidesPerView: 3,
            spaceBetween: 26,
          },
          1340: {
            slidesPerView: 4,
            spaceBetween: 17,
          },
        }}
      >
        {assets
          ? assets.map((asset, index) => (
              <SwiperSlide
                className={`${styles.swiperSlide}`}
                key={`asset${asset.id}`}
              >
                <NftCard
                  key={`${asset.id}-${index}`}
                  asset={asset}
                  yourNfts={yourNfts ?? false}
                />
              </SwiperSlide>
            ))
          : Array(count)
              .fill(0)
              .map((_, i) => (
                <Skeleton key={i} variant="rect" height={325} width={225} />
              ))}
      </Swiper>
    );
  };

  return (
    <div className="flex flex-wrap items-top xl:justify-start justify-center gap-4 w-full">
      {assets
        ? isFeaturedOrTrending
          ? carouselNftList()
          : assets.map((asset, index) => (
              <NftCard
                key={`${asset.id}-${index}`}
                asset={asset}
                yourNfts={yourNfts ?? false}
                showViewCollection={showViewCollection}
              />
            ))
        : Array(count)
            .fill(0)
            .map((_, i) => (
              <Skeleton key={i} variant="rect" height={325} width={225} />
            ))}
    </div>
  );
};
